import { useQuery } from '@tanstack/react-query';
import api from '../lib/axios';

// Gesamtreport (Reporting-Agent) je Projekt — Axios hängt ?project automatisch an.
export function useAgentReport(projectId) {
  return useQuery({
    queryKey: ['agent-report', projectId],
    enabled: !!projectId,
    queryFn: async () => (await api.get('/agent-report')).data,
  });
}
